import { createFileRoute } from "@tanstack/react-router"
import { formSettingsViewStaticData } from "src/views/FormSettingsView/constants"
import { FormSettingsView } from "src/views/FormSettingsView/FormSettingsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/forms/")({
	component: FormSettingsView,
	staticData: formSettingsViewStaticData,
})
